module.exports = __webpack_public_path__ + "static/img/coma1.be7d1a91.svg";